import { EnumService } from '../../../services/enum.service';
import { AccountsService, 
    IAccount, 
    ILocation,
    LocationService,
    Masterdata,
    MasterdataAService
    } from '../../../services';

class ContactBasicInfoController {

    private onUpdate: any;
    private contact: any;
    private type: any;
    private accounts: IAccount[];
    private locations: ILocation[];
    private contactTags: Masterdata[];

    constructor(
        private $state: ng.ui.IStateService,
        private AccountsService: AccountsService,
        private LocationService: LocationService,
        private MasterdataAService: MasterdataAService,
        private EnumService: EnumService
    ) {
        'ngInject';
        // console.log('ContactBasicInfoController');
    }

    public $onInit = () => {
        this.AccountsService.all().then((accounts) => {
            this.accounts = accounts;
        });

        if (this.contact.accountId) {
            this.getLocations();
        }

        this.getMasterdata();
    }

    submitContactBasicInfo() {
        // console.log('update ContactBasicInfo');

        this.onUpdate({ contact: this.contact });

        (<any>$('#contactBasicInfoModal')).modal('hide');
    }

    accountSelected() {
        this.getLocations();
    }

    getLocations() {
        this.AccountsService.getChild(this.contact.accountId, 'locations').then((result: any) => {
            this.locations = result;
        });
    }

    getMasterdata() {
        this.MasterdataAService.getItems('ContactTags').then(res => {
            this.contactTags = res;
        });
    }
}

export const contactBasicInfoComponent = {
    bindings: {
        contact: '<',
        onUpdate: "&"
    },
    controller: ContactBasicInfoController,
    template: require('./contactBasicInfoModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/contacts/contactBasicInfoModal.component.ts